/**
 * ⚡ Turbo-Modus (Experiment, je Gerät) für „Vinted erfassen" und „DHL erfassen".
 *
 * Idee (Philipp, 21.10.2026): Wenn Vinted oder DHL Buchung und Namen liefern, gibt es nichts mehr zu prüfen —
 * das Fach folgt aus dem Nachnamen. Dann zählt nur Tempo. Mit Turbo:
 *  - das Foto wird NACH dem Anlegen im Hintergrund hochgeladen (vorher wartete das Anlegen auf den Upload)
 *  - das Fach steht groß auf dem Bildschirm, darunter der Name — kein Blick aufs Etikett nötig
 *  - Ausnahmen (kein Name, kein Fach, nicht für diesen Shop, Rückfall) färben die Anzeige rot, mit Warnton
 *  - je Paket wird gemessen: Scan → gebucht → angelegt; Durchschnitt in der Kopfzeile, Werte im Protokoll
 * Gedruckt wird ohnehin sofort; die Druckaufträge laufen über eine Warteschlange (printerService.printRaw).
 * Seit 23.10.2026 heißt das „Turbo Vinted/DHL"; für das normale Erfassen per Foto gibt es „Turbo PaketPilot"
 * (services/turboPaketPilot.js).
 */
const KEY = 'kiosk_turbo';

export function isTurboOn() { try { return localStorage.getItem(KEY) === '1'; } catch { return false; } }
export function setTurboOn(on) {
  try {
    localStorage.setItem(KEY, on ? '1' : '0');
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new CustomEvent('kiosk:label-cfg-changed'));
    }
  } catch { /* */ }
}

const TEXTE = {
  de: {
    schalter: '⚡ Turbo Vinted/DHL (Experiment)',
    hinweis: 'Für Vinted erfassen und DHL erfassen: Fotos werden im Hintergrund hochgeladen, das Fach steht groß auf dem Bildschirm, nur Ausnahmen werden rot angezeigt. Gilt nur auf diesem Gerät.',
    badge: '⚡ TURBO', gebucht: '{n} gebucht', ausnahmen: '{n} Ausnahmen', schnitt: 'Ø {s} s je Paket', bereit: 'Bereit — Paket scannen',
    keinFach: 'Kein Fach — bitte selbst einsortieren', keinName: 'Kein Name — Platzhalter angelegt', fremd: 'Nicht für diesen Shop — in den Sack für den Fahrer',
    rueckfall: 'Nicht bestätigt — bitte in der App nachscannen', doppelt: 'Schon erfasst',
  },
  nl: {
    schalter: '⚡ Turbo Vinted/DHL (experiment)',
    hinweis: 'Voor Vinted ontvangen en DHL ontvangen: foto\'s worden op de achtergrond geüpload, het vak staat groot op het scherm, alleen uitzonderingen worden rood getoond. Geldt alleen op dit apparaat.',
    badge: '⚡ TURBO', gebucht: '{n} geboekt', ausnahmen: '{n} uitzonderingen', schnitt: 'Ø {s} s per pakket', bereit: 'Klaar — pakket scannen',
    keinFach: 'Geen vak — zelf inruimen', keinName: 'Geen naam — tijdelijke naam aangemaakt', fremd: 'Niet voor deze winkel — in de zak voor de chauffeur',
    rueckfall: 'Niet bevestigd — graag in de app nascannen', doppelt: 'Al geregistreerd',
  },
  en: {
    schalter: '⚡ Turbo Vinted/DHL (experiment)',
    hinweis: 'For Vinted intake and DHL intake: photos upload in the background, the shelf slot is shown large on screen, only exceptions turn red. Applies to this device only.',
    badge: '⚡ TURBO', gebucht: '{n} booked', ausnahmen: '{n} exceptions', schnitt: 'Ø {s} s per parcel', bereit: 'Ready — scan a parcel',
    keinFach: 'No shelf slot — please place it yourself', keinName: 'No name — placeholder created', fremd: 'Not for this shop — put it in the driver bag',
    rueckfall: 'Not confirmed — please rescan in the app', doppelt: 'Already recorded',
  },
};

export function tt(language) {
  const lang = TEXTE[language] ? language : 'en';
  return (key, vars) => {
    let s = TEXTE[lang][key] ?? TEXTE.de[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, String(v));
    return s;
  };
}
